module.exports = __webpack_public_path__ + "static/media/icon-logistic.346dd1a8.svg";